import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';
import { ReponseInfosClientRecueil } from '../../models/reponses/reponse-infos-client-recueil';

export const reponseInfosClientRecueil: ReponseEnveloppe<ReponseInfosClientRecueil> = {
    reponse:
        {
            "client":
                {
                    "nom" : "Robiaud",
                    "prenom" : "Aghate",
                    "emailDeContact" : "toto@titi.fr",
                    "ligne": "0612121212",
                    "marker": "RESI_MOTIF"
                }
        }
}

